import styled from 'styled-components';
export const Container = styled.div `
    display: flex;
    width: 100%;
    height: fit-content;
    align-items: flex-end;
    & .swiper-container {
        overflow: visible;
    }
    & .swiper-slide:hover {
        z-index: 10;
    }
`;
export const PackshotHolder = styled.div `
    transition: transform ease 200ms;
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }
    & img {
        border: ${({ isCurrentlyPlaying }) => isCurrentlyPlaying ? '4px solid #fabc0b' : 'none'} !important;
    }
`;
//# sourceMappingURL=index.js.map